function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5032 37.886C30.1033 37.886 37.8857 30.1035 37.8857 20.5034C37.8857 10.9033 30.1033 3.12085 20.5032 3.12085C10.903 3.12085 3.12061 10.9033 3.12061 20.5034C3.12061 30.1035 10.903 37.886 20.5032 37.886Z",
  stroke: "white",
  strokeWidth: 1.98658,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5037 22.9866C21.8752 22.9866 22.987 21.8748 22.987 20.5034C22.987 19.1319 21.8752 18.0201 20.5037 18.0201C19.1323 18.0201 18.0205 19.1319 18.0205 20.5034C18.0205 21.8748 19.1323 22.9866 20.5037 22.9866Z",
  stroke: "white",
  strokeWidth: 1.98658,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5034 18.0201V9.32886",
  stroke: "white",
  strokeWidth: 1.98658,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.2603 22.2598L26.7118 26.7114",
  stroke: "white",
  strokeWidth: 1.98658,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgClockWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockWhite);
export default __webpack_public_path__ + "static/media/clock-white.5674d00a.svg";
export { ForwardRef as ReactComponent };